import { useLang } from '@/i18n';
import EfBanner from 'elem/ui/ef-banner';
import EfSpec from 'elem/ui/ef-spec';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('theProduct.SectionD');

    const configs = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1737013023676/runtime.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1737013028186/runtime_m.jpg',
        label: t('label'),
        title: t('title'),
        desc: t('desc'),
    };

    return (
        <div className={styles.TheComp}>
            <EfSpec className="spec-x" />
            <EfBanner {...configs} />
        </div>
    );
}
